// extracted by mini-css-extract-plugin
export default {"levelAddButton":"levelAddButton-zccF6","levelCounter":"levelCounter-Y5X8w","icon":"icon-xav94","readonly":"readonly-AGi6y"};